import React from 'react';

import BookingStatus from 'components/BookingStatus';
import {BookingTenantsInfo} from 'components/TenantInfo';

import {formatDate} from 'utils/datetime';

import rightStrike from 'assets/icons/tail-right.svg';

import './styles.css';

const BookingInformation = ({booking}) => {
  return (
    <React.Fragment>
      {booking && (
        <div className="BookingInformation colab-centered-v colab-row-space-between colab-sidepadding-2">
          <BookingTenantsInfo
            tenants={[booking.primaryTenant, booking.secondaryTenant].filter(
              x => !!x
            )}
          />
          <div className="BookingInformation__details colab-centered-v colab-row-space-between">
            <div className="BookingInformation__details__period colab-centered-v colab-row-space-between">
              <div>{formatDate(booking.period.startDate)}</div>
              <img
                className="colab-sidepadding-1"
                src={rightStrike}
                alt="Right strike"
              />
              <div>{formatDate(booking.period.endDate)}</div>
            </div>
            <BookingStatus status={booking.status} />
          </div>
        </div>
      )}
      {!booking && <div />}
    </React.Fragment>
  );
};

export default BookingInformation;
